jQuery(document).ready(($) => {
	const vimeoUrlPattern = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i
	const youtubeUrlPattern = /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/

	const vlb = {
		linkClass: '.vlb-play',
		lightboxClass: '.vlb-lightbox',
		buttonCloseClass: '.vlb-lightbox__button-close',
		domain: 'https://wildernessfusion.com',
		vimeoAppId: '122963',
		vimeoSdkPromise: null,
		activeTracker: null,
		html: (video) => {
			let code = ''
			const link = video.url || ''
			const youtubeId = link.match(youtubeUrlPattern)
			const vimeoId = video.vimeoId || getVimeoId(link)
			const vimeoHash = getVimeoHash(link)

			if (youtubeId) {
				code = `<iframe src="https://www.youtube.com/embed/${youtubeId[1]}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
			}

			if (vimeoId) {
				const hashParam = vimeoHash ? `?h=${encodeURIComponent(vimeoHash)}&` : '?'
				code = `<iframe src="https://player.vimeo.com/video/${vimeoId}/${hashParam}app_id=${vlb.vimeoAppId}&autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen data-wfcrm-vimeo-player="1"></iframe>`
			}

			if (link.includes(vlb.domain)) {
				code = `<video autoplay controls><source src="${escapeAttribute(link)}" type="video/mp4"><p>Your browser doesn't support HTML5 video.</p></video>`
			}

			if (!code) {
				return ''
			}

			return `
        	<div class="vlb-lightbox">
        		<div class="vlb-lightbox__wrapper">
        			<div class="vlb-lightbox__video-container">
        				${code}
        			</div>
        		</div>
        		<div class="vlb-lightbox__button-close">
        			<?xml version="1.0" ?><svg height="24px" version="1.1" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title/><desc/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" id="Group"><path d="M12,10.5857864 L17.2426407,5.34314575 C17.633165,4.95262146 18.26633,4.95262146 18.6568542,5.34314575 C19.0473785,5.73367004 19.0473785,6.36683502 18.6568542,6.75735931 L13.4142136,12 L18.6568542,17.2426407 C19.0473785,17.633165 19.0473785,18.26633 18.6568542,18.6568542 C18.26633,19.0473785 17.633165,19.0473785 17.2426407,18.6568542 L12,13.4142136 L6.75735931,18.6568542 C6.36683502,19.0473785 5.73367004,19.0473785 5.34314575,18.6568542 C4.95262146,18.26633 4.95262146,17.633165 5.34314575,17.2426407 L10.5857864,12 L5.34314575,6.75735931 C4.95262146,6.36683502 4.95262146,5.73367004 5.34314575,5.34314575 C5.73367004,4.95262146 6.36683502,4.95262146 6.75735931,5.34314575 L12,10.5857864 Z" id="Path"/></g></g></svg>
        		</div>
        	</div>
        `
		}
	}

	hydrateAccountVideoLinks()

	$('body').on('click', (e) => {
		const link = $(e.target).closest('a')

		if (link.hasClass(vlb.linkClass.substring(1))) {
			e.preventDefault()
			e.stopPropagation()

			const video = getVideoFromLink(link[0])
			if (!video.url) {
				return
			}

			vlbShow(video)
			$(vlb.buttonCloseClass).on('click', () => vlbHide())
		} else {
			vlbHide()
		}
	})

	function vlbHide() {
		if (vlb.activeTracker?.destroy) {
			vlb.activeTracker.destroy()
			vlb.activeTracker = null
		}

		$(vlb.lightboxClass).fadeOut('fast', () => {
			$(vlb.lightboxClass).remove()
			$('html').removeClass('vlb-lightbox--active')
		})
	}

	function vlbShow(video) {
		const html = vlb.html(video)
		if (!html) {
			return
		}

		$('body').prepend(html)
		$(vlb.lightboxClass).fadeTo(1, 'fast')
		$('html').addClass('vlb-lightbox--active')
		trackVimeoPlayer(video)
	}

	function getVideoFromLink(link) {
		return {
			resourceId: parseInt(link.dataset.wfcrmResourceId || link.dataset.resourceId || '0', 10) || 0,
			name: link.dataset.wfcrmVideoName || link.dataset.videoName || link.getAttribute('title') || link.textContent.trim(),
			url: link.dataset.wfcrmVideoUrl || link.dataset.videoUrl || link.getAttribute('href') || '',
			vimeoId: link.dataset.wfcrmVimeoId || link.dataset.vimeoId || ''
		}
	}

	function hydrateAccountVideoLinks() {
		const config = window.wfcrmVideoTracking || {}
		const videos = Array.isArray(config.accountVideos) ? config.accountVideos : []
		if (!videos.length) {
			return
		}

		document.querySelectorAll('a.vlb-play.toggle-video-player').forEach((link, index) => {
			if (link.getAttribute('href') || link.dataset.videoUrl || link.dataset.wfcrmVideoUrl) {
				return
			}

			const video = videos[index]
			if (!video?.url) {
				return
			}

			link.dataset.wfcrmVideoUrl = video.url
			link.dataset.wfcrmResourceId = String(video.id || '')
			link.dataset.wfcrmVideoName = video.name || ''
			link.dataset.wfcrmVimeoId = getVimeoId(video.url)
			link.setAttribute('title', video.name || '')
		})
	}

	function trackVimeoPlayer(video) {
		if (!getVimeoId(video.url) && !video.vimeoId) {
			return
		}

		const iframe = document.querySelector(`${vlb.lightboxClass} iframe[data-wfcrm-vimeo-player="1"]`)
		if (!iframe) {
			return
		}

		loadVimeoSdk().then(() => {
			if (!window.Vimeo?.Player || !document.body.contains(iframe)) {
				return
			}

			const player = new window.Vimeo.Player(iframe)
			const sessionId = createSessionId()
			const sent = new Set()
			const sendOnce = (eventType, progressPercent, data = {}) => {
				const key = `${eventType}:${progressPercent}`
				if (sent.has(key)) {
					return
				}

				sent.add(key)
				sendTrackingEvent(video, sessionId, eventType, progressPercent, data)
			}

			player.on('play', (data) => {
				sendOnce('play', 0, data)
			})

			player.on('timeupdate', (data) => {
				const percent = Math.floor((data.percent || 0) * 100)
				const milestone = Math.floor(percent / 10) * 10

				if (milestone >= 10 && milestone <= 100) {
					sendOnce('progress', milestone, data)
				}
			})

			player.on('ended', (data) => {
				sendOnce('progress', 100, data)
			})

			vlb.activeTracker = {
				destroy: () => {
					player.unload().catch(() => {})
				}
			}
		}).catch(() => {})
	}

	function sendTrackingEvent(video, sessionId, eventType, progressPercent, data) {
		const config = window.wfcrmVideoTracking || {}
		if (!config.ajaxUrl || !config.nonce || !config.isLoggedIn) {
			return
		}

		const body = new URLSearchParams({
			action: 'wfcrm_track_vimeo_progress',
			nonce: config.nonce,
			event_type: eventType,
			progress_percent: String(progressPercent),
			resource_id: String(video.resourceId || 0),
			video_name: video.name || '',
			video_url: video.url || '',
			vimeo_id: video.vimeoId || getVimeoId(video.url),
			session_id: sessionId,
			page_url: window.location.href,
			page_title: document.title || '',
			seconds: String(data.seconds || 0),
			duration: String(data.duration || 0)
		})

		window.fetch(config.ajaxUrl, {
			body,
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			},
			method: 'POST',
			keepalive: true
		}).catch(() => {})
	}

	function loadVimeoSdk() {
		if (window.Vimeo?.Player) {
			return Promise.resolve()
		}

		if (vlb.vimeoSdkPromise) {
			return vlb.vimeoSdkPromise
		}

		vlb.vimeoSdkPromise = new Promise((resolve, reject) => {
			const script = document.createElement('script')
			script.src = 'https://player.vimeo.com/api/player.js'
			script.async = true
			script.onload = resolve
			script.onerror = reject
			document.head.appendChild(script)
		})

		return vlb.vimeoSdkPromise
	}

	function getVimeoId(url) {
		const match = String(url || '').match(vimeoUrlPattern)

		return match ? match[1] : ''
	}

	function getVimeoHash(url) {
		try {
			const parsed = new URL(url)
			const queryHash = parsed.searchParams.get('h')
			if (queryHash) {
				return queryHash
			}

			const parts = parsed.pathname.split('/').filter(Boolean)
			const idIndex = parts.findIndex((part) => /^\d+$/.test(part))

			return idIndex >= 0 && parts[idIndex + 1] ? parts[idIndex + 1] : ''
		} catch (error) {
			return ''
		}
	}

	function createSessionId() {
		if (window.crypto?.randomUUID) {
			return window.crypto.randomUUID()
		}

		return `vimeo-${Date.now()}-${Math.random().toString(36).slice(2)}`
	}

	function escapeAttribute(value) {
		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/"/g, '&quot;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
	}
})
